import { lazy } from 'react';

const LeasesApplies = lazy(() =>
  import('components/Managements/Leases/LeasesApplies/index').then(module => ({
    default: module.LeasesApplies,
  }))
);

const LeasesContracts = lazy(() =>
  import('components/Managements/Leases/LeasesContracts/index').then(module => ({
    default: module.LeasesContracts,
  }))
);

const LeasesPayments = lazy(() =>
  import('components/Managements/Leases/LeasesPayments/index').then(module => ({
    default: module.LeasesPayments,
  }))
);

const LeasesManagements = lazy(() =>
  import('components/Managements/Leases/LeasesManagements/MainScreen/index').then(module => ({
    default: module.LeasesManagements,
  }))
);

const FormManagement = lazy(() =>
  import('components/Managements/Leases/LeasesManagements/FormManagement/index').then(module => ({
    default: module.FormManagement,
  }))
);

const VehiclesApplies = lazy(() =>
  import('components/Managements/Vehicles/VehiclesApplies/VehiclesApplies').then(module => ({
    default: module.VehiclesApplies,
  }))
);

const VehiclesSales = lazy(() =>
  import('components/Managements/Vehicles/VehiclesSales/VehiclesSales').then(module => ({
    default: module.VehiclesSales,
  }))
);

const VehiclesPayments = lazy(() =>
  import('components/Managements/Vehicles/VehiclesPayments/VehiclesPayments').then(module => ({
    default: module.VehiclesPayments,
  }))
);

const VehiclesManagements = lazy(() =>
  import('components/Managements/Vehicles/VehiclesManagements/MainScreen/VehicleManagements').then(module => ({
    default: module.VehiclesManagements,
  }))
);

const FormVehiclesManagement = lazy(() =>
  import('components/Managements/Vehicles/VehiclesManagements/FormManagement/FormVehiclesManagement').then(module => ({
    default: module.FormVehiclesManagement,
  }))
);

const VehiclesCredits = lazy(() =>
  import('components/Managements/Vehicles/VehiclesCredits/VehiclesCredits').then(module => ({
    default: module.VehiclesCredits,
  }))
);

const ManagementUncollectibleCredits = lazy(() =>
  import('components/Managements/Vehicles/VehicleUncollectibleCredits/VehicleUncollectibleCredits').then(module => ({
    default: module.ManagementUncollectibleCredits,
  }))
);

const Credits = lazy(() =>
  import('components/Managements/Credits/Credits/Credits').then(module => ({
    default: module.Credits,
  }))
);

const CreditsApplies = lazy(() =>
  import('components/Managements/Credits/CreditsApplies/CreditsApplies').then(module => ({
    default: module.CreditsApplies,
  }))
);

const CreditsPayments = lazy(() =>
  import('components/Managements/Credits/CreditsPayments/CreditsPayments').then(module => ({
    default: module.CreditsPayments,
  }))
);

const CreditsManagements = lazy(() =>
  import('components/Managements/Credits/CreditsManagments/MainScreen/CreditsManagements').then(module => ({
    default: module.CreditsManagements,
  }))
);

const FormCreditsManagement = lazy(() =>
  import('components/Managements/Credits/CreditsManagments/FormManagement/FormCreditsManagement').then(module => ({
    default: module.FormCreditsManagement,
  }))
);

const CreditsCollateral = lazy(() =>
  import('components/Managements/Credits/CreditsCollateral/CreditsCollateral').then(module => ({
    default: module.CreditsCollateral,
  }))
);

const UncollectibleCredits = lazy(() =>
  import('components/Managements/Credits/UncollectibleCredits/UncollectibleCredits').then(module => ({
    default: module.UncollectibleCredits,
  }))
);

const GeneralManagements = lazy(() =>
  import('components/Managements/GeneralManagements/index').then(module => ({
    default: module.GeneralManagements,
  }))
);

const routesManagements = [
  {
    path: null,
    name: "Arrendamientos",
    icon: "nc-icon nc-paper",
    component: null,
    permissions: ['94_ARRENDAMIENTOS'], //TODO: Cambiar permiso
    layout: null,
    visibility: true,
    subRoutes: [
      {
        path: "/gestiones-arrendamientos-contratos",
        name: "Contratos",
        icon: "nc-icon nc-paper",
        component: <LeasesContracts />,
        permissions: ['211_ARRENDAMIENTOS_CONTRATOS'],
        layout: "/app",
        visibility: true,
        subRoutes: [],
      },
      {
        path: "/gestiones/arrendamientos/solicitudes",
        name: "Solicitudes",
        icon: "nc-icon nc-paper",
        component: <LeasesApplies />,
        permissions: ['96_ARRENDAMIENTOS_SOLICITUDES'],
        layout: "/app",
        visibility: true,
        subRoutes: [],
      },
      {
        path: "/gestiones/arrendamientos/pagos",
        name: "Pagos",
        icon: "nc-icon nc-paper",
        component: <LeasesPayments />,
        permissions: ['97_ARRENDAMIENTOS_PAGOS'],
        layout: "/app",
        visibility: true,
        subRoutes: [],
      },
      {
        path: "/gestiones/arrendamientos/gestiones",
        name: "Otras gestiones",
        icon: "nc-icon nc-paper",
        component: <LeasesManagements />,
        permissions: ['98_ARRENDAMIENTOS_GESTIONES'],
        layout: "/app",
        visibility: true,
        subRoutes: [],
      },
      {
        path: "/gestiones-arrendamientos-form",
        name: "Formulario Gestiones",
        icon: "nc-icon nc-paper",
        component: <FormManagement />,
        permissions: ['98_ARRENDAMIENTOS_GESTIONES'],
        layout: "/app",
        visibility: false,
        subRoutes: [],
      },
      {
        path: "/gestiones-arrendamientos-form/edit/:idgestion",
        name: "Formulario Gestiones",
        icon: "nc-icon nc-paper",
        component: <FormManagement />,
        permissions: ['98_ARRENDAMIENTOS_GESTIONES'],
        layout: "/app",
        visibility: false,
        subRoutes: [],
      },
      {
        path: "/gestiones-arrendamientos-form/info/:idgestion",
        name: "Formulario Gestiones",
        icon: "nc-icon nc-paper",
        component: <FormManagement />,
        permissions: ['98_ARRENDAMIENTOS_GESTIONES'],
        layout: "/app",
        visibility: false,
        subRoutes: [],
      }
    ],
  },
  {
    path: null,
    name: "Vehículos",
    icon: "nc-icon nc-paper",
    component: null,
    permissions: ['100_VEHICULOS'],
    layout: null,
    visibility: true,
    subRoutes: [
      {
        path: "/gestiones-vehiculos-ventas",
        name: "Ventas",
        icon: "nc-icon nc-paper",
        component: <VehiclesSales />,
        permissions: ['101_VEHICULOS_VENTAS'],
        layout: "/app",
        visibility: true,
        subRoutes: [],
      },
      {
        path: "/gestiones-vehiculos-creditos",
        name: "Creditos",
        icon: "nc-icon nc-paper",
        component: <VehiclesCredits />,
        permissions: ['204_VEHICULOS_CREDITOS'],
        layout: "/app",
        visibility: true,
        subRoutes: [],
      },
      {
        path: "/gestiones-vehiculos-solicitudes",
        name: "Solicitudes",
        icon: "nc-icon nc-paper",
        component: <VehiclesApplies />,
        permissions: ['102_VEHICULOS_SOLICITUDES'],
        layout: "/app",
        visibility: true,
        subRoutes: [],
      },
      {
        path: "/gestiones-vehiculos-pagos",
        name: "Pagos",
        icon: "nc-icon nc-paper",
        component: <VehiclesPayments />,
        permissions: ['103_VEHICULOS_PAGOS'],
        layout: "/app",
        visibility: true,
        subRoutes: [],
      },
      {
        path: "/gestiones-vehiculos-gestiones",
        name: "Gestiones",
        icon: "nc-icon nc-paper",
        component: <VehiclesManagements />,
        permissions: ['104_VEHICULOS_GESTIONES'],
        layout: "/app",
        visibility: true,
        subRoutes: [],
      },
      {
        path: "/gestiones-vehiculos-form",
        name: "Formulario Gestiones",
        icon: "nc-icon nc-paper",
        component: <FormVehiclesManagement />,
        permissions: ['104_VEHICULOS_GESTIONES'],
        layout: "/app",
        visibility: false,
        subRoutes: [],
      },
      {
        path: "/gestiones-vehiculos-form/edit/:idgestion",
        name: "Formulario Gestiones",
        icon: "nc-icon nc-paper",
        component: <FormVehiclesManagement />,
        permissions: ['104_VEHICULOS_GESTIONES'],
        layout: "/app",
        visibility: false,
        subRoutes: [],
      },
      {
        path: "/gestiones-vehiculos-form/info/:idgestion",
        name: "Formulario Gestiones",
        icon: "nc-icon nc-paper",
        component: <FormVehiclesManagement />,
        permissions: ['104_VEHICULOS_GESTIONES'],
        layout: "/app",
        visibility: false,
        subRoutes: [],
      },
      {
        path: "/gestiones-vehiculos-creditos-incobrables",
        name: "Creditos Incobrables",
        icon: "nc-icon nc-paper",
        component: <ManagementUncollectibleCredits />,
        permissions: ['208_VEHICULOS_CREDITOS_INCOBRABLES'],
        layout: "/app",
        visibility: true,
        subRoutes: [],
      }
    ],
  },
  {
    path: null,
    name: "Creditos",
    icon: "nc-icon nc-paper",
    component: null,
    permissions: ['106_CREDITOS'],
    layout: null,
    visibility: true,
    subRoutes: [
      {
        path: "/gestiones-creditos-creditos",
        name: "Creditos",
        icon: "nc-icon nc-paper",
        component: <Credits />,
        permissions: ['235_CREDITOS'],
        layout: "/app",
        visibility: true,
        subRoutes: [],
      },

      {
        path: "/gestiones-creditos-solicitudes",
        name: "Solicitudes",
        icon: "nc-icon nc-paper",
        component: <CreditsApplies />,
        permissions: ['107_CREDITOS_SOLICITUDES'],
        layout: "/app",
        visibility: true,
        subRoutes: [],
      },
      {
        path: "/gestiones-creditos-pagos",
        name: "Pagos",
        icon: "nc-icon nc-paper",
        component: <CreditsPayments />,
        permissions: ['108_CREDITOS_PAGOS'],
        layout: "/app",
        visibility: true,
        subRoutes: [],
      },
      {
        path: "/gestiones-creditos-gestiones",
        name: "Gestiones",
        icon: "nc-icon nc-paper",
        component: <CreditsManagements />,
        permissions: ['109_CREDITOS_GESTIONES'],
        layout: "/app",
        visibility: true,
        subRoutes: [],
      },
      {
        path: "/gestiones-creditos-form",
        name: "Formulario Gestiones",
        icon: "nc-icon nc-paper",
        component: <FormCreditsManagement />,
        permissions: ['109_CREDITOS_GESTIONES'],
        layout: "/app",
        visibility: false,
        subRoutes: [],
      },
      {
        path: "/gestiones-creditos-form/edit/:idgestion",
        name: "Formulario Gestiones",
        icon: "nc-icon nc-paper",
        component: <FormCreditsManagement />,
        permissions: ['109_CREDITOS_GESTIONES'],
        layout: "/app",
        visibility: false,
        subRoutes: [],
      },
      {
        path: "/gestiones-creditos-form/info/:idgestion",
        name: "Formulario Gestiones",
        icon: "nc-icon nc-paper",
        component: <FormCreditsManagement />,
        permissions: ['109_CREDITOS_GESTIONES'],
        layout: "/app",
        visibility: false,
        subRoutes: [],
      },
      {
        path: "/gestiones-creditos-garantias",
        name: "Garantias",
        icon: "nc-icon nc-paper",
        component: <CreditsCollateral />,
        permissions: ['239_CREDITOS_GARANTIAS'],
        layout: "/app",
        visibility: true,
        subRoutes: [],
      },
      {
        path: "/gestiones-creditos-incobrables",
        name: "Creditos Incobrables",
        icon: "nc-icon nc-paper",
        component: <UncollectibleCredits />,
        permissions: ['236_CREDITOS_INCOBRABLES'],
        layout: "/app",
        visibility: true,
        subRoutes: [],
      }
    ],
  },
  {
    path: null,
    name: "Gestiones Generales",
    icon: "nc-icon nc-paper",
    component: null,
    permissions: ['248_GESTIONES_GENERALES'],
    layout: null,
    visibility: true,
    subRoutes: [
      {
        path: "/gestiones/generales/activas",
        name: "Gestiones Activas",
        icon: "nc-icon nc-paper",
        component: <GeneralManagements />,
        permissions: ['249_GESTIONES_ACTIVAS'],
        layout: "/app",
        visibility: true,
        subRoutes: [],
      },

      {
        path: "/gestiones/generales/cerradas",
        name: "Gestiones Cerradas",
        icon: "nc-icon nc-paper",
        component: <GeneralManagements />,
        permissions: ['250_GESTIONES_CERRADAS'],
        layout: "/app",
        visibility: true,
        subRoutes: [],
      }
    ],
  },
];

export {
  routesManagements
}